import { Injectable, inject } from '@angular/core';
import { StorageService } from '../db/StorageService';

export type ThemeMode = 'dark' | 'light';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly storageService = inject(StorageService);
  private readonly storeKey = 'theme-mode';

  setDarkMode(): Promise<void> {
    document.body.classList.add('dark');
    return this.saveThemeMode('dark');
  }

  disableDarkMode(): Promise<void> {
    document.body.classList.remove('dark');
    return this.saveThemeMode('light');
  }

  /** Atajo para toggles: aplica y persiste según el estado del control. */
  setDarkModeEnabled(enabled: boolean): Promise<void> {
    return enabled ? this.setDarkMode() : this.disableDarkMode();
  }

  saveThemeMode(mode: ThemeMode): Promise<void> {
    return this.storageService.store(this.storeKey, mode);
  }

  getThemeMode(): Promise<ThemeMode | null> {
    return this.storageService.findByKey(this.storeKey);
  }

  // Applies the persisted theme once (app startup). The toggle path must NOT
  // re-read storage — async storage can return a stale value and flip the
  // theme back (the "double toggle" bug).
  async applyThemeMode(): Promise<void> {
    const mode = await this.getThemeMode();
    if (mode === 'dark') {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  }
}
